






































import Vue from 'vue'
import UiCard from '@/components/UiCard.vue'
import UiButton from '@/components/UiButton.vue'
import UiIcon from '@/components/UiIcon.vue'

export default Vue.extend({
  name: "EmailAction",
  data(){
    return {
      password: '',
      passwordConfirm: '',
      submitFailed: false,
      errorCode: '',
      submitSuccess: false,
      loadingSubmit: false,
    }
  },
  computed: {},
  methods: {
    isPasswordResetType(){
      return this.parameters().mode == "resetPassword"
    },
    parameters(){
      return this.$route.query
    },
    async handleSubmit(e: Event){
      e.preventDefault()

      // make sure the password was typed in twice:
      if(this.password != this.passwordConfirm){
        this.errorCode = "passwords-dont-match"
        this.submitSuccess = false
        this.submitFailed = true
        return
      }
      
      // Try submit
      try {
        this.loadingSubmit = true
        this.submitFailed = false
        await this.$store.dispatch('setPassword', {
          code: this.parameters().oobCode,
          newPassword: this.password
        })
        this.password = ''
        this.submitSuccess = true
      } catch (error) {
        console.error("ERROR Submitting", error)
        this.errorCode = "failed"
        this.submitSuccess = false
        this.submitFailed = true
      } finally {
        this.loadingSubmit = false
      }
    }
  },
  components: {
    UiCard,
    UiButton,
    UiIcon,
  }
})
